// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Stats-cls1___ad1e45090a97d04aaa5{/*!*/}.Stats-cls2___904ddec42773f6577a6{display:flex;align-items:center}.Stats-cls2___904ddec42773f6577a6>*:not(:first-child):before{content:\"•\";margin:0 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Stats-cls1___ad1e45090a97d04aaa5",
	"cls2": "Stats-cls2___904ddec42773f6577a6 Stats-cls1___ad1e45090a97d04aaa5"
};
export default ___CSS_LOADER_EXPORT___;
